import { Button, Typography } from '@volvo/vcdk-react';
import { Trans, useTranslation } from 'react-i18next';

import { withComponentErrorBoundary } from '@/components/ComponentErrorBoundary';

type Props = {
  onCancel: () => void;
  onNext: () => void;
};

const IndustrialUnitAddedContent: React.FC<Props> = ({ onCancel, onNext }) => {
  const { t } = useTranslation();

  return (
    <>
      <span slot="header">{t(($) => $.components.modal.add_new_unit_modal.industrial_unit_added.title)}</span>
      <div className="flex flex-col gap-8">
        <Typography>{t(($) => $.components.modal.add_new_unit_modal.industrial_unit_added.description)}</Typography>
        <div className="flex flex-col gap-4">
          <Typography variant="subtitle2">
            {t(($) => $.components.modal.add_new_unit_modal.industrial_unit_added.manual_ownership_registration)}
          </Typography>
          <Typography>
            <Trans
              i18nKey={($) =>
                $.components.modal.add_new_unit_modal.industrial_unit_added.manual_ownership_registration_description
              }
              components={{
                b: <strong />,
              }}
            />
          </Typography>
        </div>
      </div>
      <span slot="modalFooter">
        <div className="flex gap-4">
          <Button variant="secondary" onClick={onCancel}>
            {t(($) => $.components.modal.add_new_unit_modal.industrial_unit_added.add_another_unit)}
          </Button>
          <Button variant="primary" onClick={onNext}>
            {t(($) => $.components.modal.add_new_unit_modal.industrial_unit_added.go_to_unit)}
          </Button>
        </div>
      </span>
    </>
  );
};

export default withComponentErrorBoundary(IndustrialUnitAddedContent);
